<template lang="html">
<div class="coupon-tips sl-coupon" v-loading="fullLoading
">
  <row>
    <div class="sl-col-4">
      <div class="sl-coupon-form">
        <p class="title">{{$t('Views.CouponsTips.title')}}</p>
        <img src="../../assets/imgs/center.png" class="coupon-tips-center">
        <p class="coupon-tips-1">{{$t('Views.CouponsTips.tip1')}}</p>
        <p class="coupon-tips-2">{{$t('Views.CouponsTips.tip2')}}</p>
        <img src="../../assets/imgs/down.png" class="coupon-tips-down">
        <div class="coupon-tips-btm">
          <div class="coupon-tips-btm-item">
            <img src="../../assets/imgs/letter.png" alt="">
            <span>{{email}}</span>
          </div>
          <div class="coupon-tips-btm-item">
            <img src="../../assets/imgs/phone.png" alt="">
            <span>{{number}}</span>
          </div>
        </div>
      </div>
    </div>
  </row>
</div>
</template>
<script>
export default {
  data() {
    return {
      fullLoading: false
    }
  },
  computed: {
    email() {
      return (this.$route.query.email && this.$route.query.email !== '') ? this.$route.query.email : this.$store.state.theme.companyInfo.email
    },
    number() {
      return (this.$route.query.number && this.$route.query.number !== '') ? this.$route.query.number : this.$store.state.theme.companyInfo.phone
    }
  }
}
</script>
<style scoped>
.coupon-tips .sl-coupon-form {
  text-align: center;
}

.coupon-tips p.title {
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  line-height: 14px;
  padding: 20px 0;
  line-height: 25px;
}

@media only screen and (max-width: 768px) {
  .coupon-tips p.title {
    max-width: none;
    margin: 0 auto;
    padding: 20px 0;
  }
  .coupon-tips-btm {
    flex-wrap: wrap;
  }
  div.coupon-tips-btm-item {
    border-top: none;
  }
  img.coupon-tips-center {
    height: 222px;
    width: 222px;
  }
}

.coupon-tips-down {
  margin-bottom: 10px;
  height: 14px;
  width: 18px;
}

.coupon-tips-center {
  margin-bottom: 20px;
  height: 333px;
  width: 333px;
}

.coupon-tips .coupon-tips-1 {
  font-size: 16px;
  color: #20a0ff;
  line-height: 22px;
  margin: 0;
}

.coupon-tips .coupon-tips-2 {
  font-family: Avenir-Medium;
  color: #20a0ff;
  line-height: 22px;
}

.coupon-tips-btm {
  display: flex;
  justify-content: center;
  font-size: 20px;
  color: #20a0ff;
  line-height: 20px;
  padding-bottom: 10px;
}

.coupon-tips-btm-item:first-child {
  padding-right: 20px;
}

.coupon-tips-btm-item {
  padding-top: 30px;
  border-top: 1px solid #E0E0E0;
}

.coupon-tips-btm img {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// coupon-tips.vue?7c138904